var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 3.3335H2.67136V4.66683H1.33203V3.3335Z",
    fill: "#98A3B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9987 3.3335H14.6654V4.66683H3.9987V3.3335Z",
    fill: "#98A3B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 7.3335H2.67136V8.66683H1.33203V7.3335Z",
    fill: "#98A3B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9987 7.3335H14.6654V8.66683H3.9987V7.3335Z",
    fill: "#98A3B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 11.3335H2.67136V12.6668H1.33203V11.3335Z",
    fill: "#98A3B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9987 11.3335H14.6654V12.6668H3.9987V11.3335Z",
    fill: "#98A3B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDot);
export default __webpack_public_path__ + "static/media/list-dot.463ffc2b97a71df48eb4fa0e643c2d39.svg";
export { ForwardRef as ReactComponent };